// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"1495a1a2","856":"3f3efd03"}[chunkId] + ".js";
};